
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import * as React from "react";
import Modal from "@insite/mobius/Modal";
import { useState } from "react";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import validateEmail from "@insite/client-framework/Common/Utilities/validateEmail";
import siteMessage from "@insite/client-framework/SiteMessage";
import { programInquiryService } from "@WhiteCap/Services/ProgramInquiryService";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";
import getColor from "@insite/mobius/utilities/getColor";
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography from "@insite/mobius/Typography";
import SuccessIcon from "@WhiteCap/Icons/SuccessIcon";



const enum fields {
	emailRecipients = "emailRecipients",
}

const emailsRegexp = new RegExp(
	"^[\\W]*([\\w+\\-.%]+@[\\w\\-.]+\\.[A-Za-z]{2,4}[\\W]*,{1}[\\W]*)*([\\w+\\-.%]+@[\\w\\-.]+\\.[A-Za-z]{2,4})[\\W]*$",
);

interface OwnProps extends WidgetProps {
	fields: {
		[fields.emailRecipients]: string;
	};
}

type Props = OwnProps & WidgetProps;




export interface ProductInquiryStyles {
	userNameTextField?: TextFieldPresentationProps;
	modalWrapper?: InjectableCss;
	form?: InjectableCss;
	shareMessageTextArea?: TextAreaProps;
	submitBtn?: InjectableCss;
	btnWrapper?: InjectableCss;
	btnHolder?: InjectableCss;
	successMessage?: InjectableCss;
}

export const productInquiryStyles: ProductInquiryStyles = {
	modalWrapper: {
		css: css`
			div[aria-labelledby="modalTitle"] {
				border-radius: 10px;
				margin: 25px auto;
				max-height: Calc(100vh - 50px);
				min-height: Calc(100vh - 50px);
				max-width: 700px;
				justify-content: center;
				${({ theme }: { theme: BaseTheme }) =>
				breakpointMediaQueries(
					theme,
					[
						css`
							max-width: Calc(100vw - 30px);
							min-height: Calc(100vh - 43vh);
					`,
						css`
							max-width: Calc(100vw - 30px);
							min-height: Calc(100vh - 43vh);
					`,
						null,
					],
					"max",
				)}
				
				#modalTitle{
					border-bottom: 0;
					padding: 0;
					#CloseModalButton{
						position: absolute;
						right: 22px;
						top: 7px;
					}
				}
			}
		`
	},
	form: {
		css: css`
			font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
			label{
				font-weight: 400;
				font-style: normal;
				font-size: 14px;
				color: #333;
				min-height: unset;
			}
			input{
				background: #fff !important;
				border: 1px solid #6f6f6f !important;
				border-radius: 1px !important;
				font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
				font-size: 14px !important;
				line-height: 1.42857143 !important;
				font-weight: 400 !important;
				border-width: 1px !important;
				height: 40px !important;
				border: 1px solid #e3e3e3 !important;
    			border-radius: 4px !important;
				&:focus{
					outline: none !important;
				}
				&[aria-invalid="true"]{
					border: 1px solid ${getColor("danger.main")} !important;
				}
			}
			div[class^="FormInputWrapper"]{
				margin-bottom: 20px;
				position: relative;
			}
			div[class^="DescriptionWrapper"]{
				position: absolute;
				margin: 0 !important;
				width: 100%;
				span{
					color: ${getColor("danger.main")};
					font-size: 12px;
					font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
					font-weight: 400;
				}
			}
			
		`
	},
	shareMessageTextArea: {
		css: css`
			background: #fff !important;
			height: 100px !important;
			border: 1px solid #e3e3e3 !important;
    		font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
			font-size: 14px !important;
			line-height: 1.42857143 !important;
			font-weight: 400 !important;
			width: 100% !important;
			border-width: 1px !important;
			border-radius: 4px !important;
			height: 100px !important;
			&:focus{
				outline: none !important;
				padding: 10px 10px 8px 10px !important;
			}
			&:placeholder {
				color: #fff !important;
			}
			&[aria-invalid="true"]{
				border: 1px solid ${getColor("danger.main")} !important;
			}
		`
	},
	btnWrapper: {
		css: css`
			display:flex;
			justify-content: center;
			align-items: center;
			button{
				border-radius: 3px;
				background: linear-gradient(to bottom, #fbd453 0%, #eab100 100%);
				font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
				padding: 10px;
			}
		`
	},
	btnHolder: {
		css: css`
			margin: 60px 0 60px 0;
		`
	},
	successMessage: {
		css: css`
			p{
				text-align: center;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 10px;
				background: #e5efe5;
				color: #006400;
				svg{
					width: 30px;
					flex: none;
    				margin-right: 10px;
				}
			}
		`
	},
	submitBtn: {
		css: css`
			padding: 10px 30px !important;
		`
	}
};

const styles = productInquiryStyles;



const programInfo: React.FC<Props> = ({ id, fields }: Props) => {
	const StyledForm = getStyledWrapper("form");
	const { emailRecipients } = fields;
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [name, setName] = useState("");
	const [companyName, setCompanyName] = useState("");
	const [emailAddress, setEmailAddress] = useState("");
	const [message, setMessage] = useState("");
	const [isSubmitted, setIsSubmitted] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [successMessage, showSuccessMessage] = useState(false);

	const requiredFieldMessage = translate("This is a required field");
	const emailRequiredFieldMessage = siteMessage("CreateNewAccountInfo_EmailAddress_Required");
	const emailFieldMessage = siteMessage("CreateNewAccountInfo_EmailAddress_ValidEmail");



	const [nameError, setNameError] = useState(requiredFieldMessage);
	const [companyNameError, setCompanyNameError] = useState(requiredFieldMessage);
	const [emailError, setEmailError] = useState(emailRequiredFieldMessage);
	const [messageError, setMessageError] = useState(requiredFieldMessage);

	const openForm = () => {
		setIsModalOpen(true);
	}

	const modalCloseHandler = () => {
		setIsModalOpen(false);
	};

	const validateName = (name: string) => {
		const errorMessage = !name ? requiredFieldMessage : "";
		setNameError(errorMessage);
		return !errorMessage;
	};

	const validateCompanyName = (companyName: string) => {
		const errorMessage = !companyName ? requiredFieldMessage : "";
		setCompanyNameError(errorMessage);
		return !errorMessage;
	}

	const validateMessage = (message: string) => {
		const errorMessage = !message ? requiredFieldMessage : "";
		setMessageError(errorMessage);
		return !errorMessage;
	}

	const nameChangeHandler = (name: string) => {
		validateName(name);
		setName(name);
	};

	const companyNameChangeHandler = (companyName: string) => {
		validateCompanyName(companyName);
		setCompanyName(companyName);
	}

	const emailChangeHandler = (email: string) => {
		const errorMessage = !email ? emailRequiredFieldMessage : validateEmail(email) ? "" : emailFieldMessage;
		setEmailError(errorMessage);
		setEmailAddress(email);
	};

	const messageChangeHandler = (message: string) => {
		validateMessage(message);
		setMessage(message);
	}




	const validateSubmitEnabled = () => {
		return !(nameError || companyNameError || emailError || messageError);
	};

	const isSubmitEnabled = validateSubmitEnabled();


	const submitHandler = (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		if (!isSubmitted) {
			setIsSubmitted(true);
		}

		if (!validateSubmitEnabled()) {
			return;
		}
		setIsSubmitting(true);
		inquiryStore();

	};


	const inquiryStore = async () => {
		const sanitizedEmailRecipients = emailRecipients.replace(/\s/g, '').replace(/,\n/g, ',')
		try {
			const response = await programInquiryService({
				type: "OnSiteContactUs",
				name,
				companyName,
				emailAddress,
				message,
				emailTo: sanitizedEmailRecipients,
			});

			if (response?.successful === true) {
				onSuccessHandler();
			}

		} catch (error) {
			console.error("Error submitting quote:", error);
		} finally {
			setIsSubmitting(false);
		}
	}

	const onSuccessHandler = () => {
		showSuccessMessage(true);
		setTimeout(() => showSuccessMessage(false), 5000);
		clearForm();
	};

	const clearForm = () => {
		setName("");
		setCompanyName("");
		setEmailAddress("");
		setMessage("");
		setIsSubmitted(false);
		setNameError(requiredFieldMessage);
		setCompanyNameError(requiredFieldMessage);
		setEmailError(emailRequiredFieldMessage);
		setMessageError(requiredFieldMessage);
	}

	return (
		<>
			<StyledWrapper {...styles.btnHolder}>
				<StyledWrapper {...styles.btnWrapper}>
					<Button variant="primary" onClick={openForm}>{translate("Let's Get You Started! Contact Your White Cap Sales Representative or Your Local Branch.")}</Button>
				</StyledWrapper>
			</StyledWrapper>

			<StyledWrapper className="modal-wrapper" >
				<Modal
					isOpen={isModalOpen}
					handleClose={modalCloseHandler}
					{...styles.modalWrapper}
				>
					{!successMessage && (
						<StyledForm onSubmit={submitHandler} noValidate {...styles.form}>
							<TextField
								{...styles.userNameTextField}
								label={translate("Name")}
								value={name}
								data-test-selector="product_form_name"
								onChange={e => nameChangeHandler(e.currentTarget.value)}
								error={isSubmitted && nameError}
								maxLength={256}
								required
							/>
							<TextField
								{...styles.userNameTextField}
								label={translate("Company")}
								value={companyName}
								data-test-selector="Product_form_CompanyName"
								onChange={e => companyNameChangeHandler(e.currentTarget.value)}
								error={isSubmitted && companyNameError}
								maxLength={256}
								required
							/>
							<TextField
								{...styles.userNameTextField}
								type="email"
								label={translate("Email Address")}
								onChange={e => emailChangeHandler(e.currentTarget.value)}
								value={emailAddress}
								data-test-selector="email"
								maxLength={256}
								required
								error={isSubmitted && emailError}
							/>
							<TextArea
								{...styles.shareMessageTextArea}
								label={translate("Message")}
								placeholder="Tell us about the products you frequently order (products, quantities, and so on) as well as any other details you’d like us to provide for your free, no obligation follow-up on an On-Site Solution program"
								value={message}
								data-test-selector="Product_form_Message"
								onChange={e => messageChangeHandler(e.currentTarget.value)}
								error={isSubmitted && messageError}
								maxLength={256}
								required

							/>
							<StyledWrapper {...styles.btnWrapper}>
								<Button
									type="submit"
									disabled={isSubmitting || (isSubmitted && !isSubmitEnabled)}
									data-test-selector="submit_button"
									{...styles.submitBtn}
								>
									{translate("Submit")}
								</Button>
							</StyledWrapper>
						</StyledForm>
					)
					}

					{successMessage && (
						<StyledWrapper {...styles.successMessage}>
							<Typography as="p"> <SuccessIcon /> {siteMessage("Prdouct_Inquiry_Form_Success_Message")}</Typography>
						</StyledWrapper>
					)}
				</Modal>
			</StyledWrapper>

		</>

	);
};


const basicTab = {
	displayName: "Basic",
	sortOrder: 0,
};


const widgetModule: WidgetModule = {
	component: programInfo,
	definition: {
		displayName: "Product Inquiry Form",
		group: "Common",
		fieldDefinitions: [
			{
				name: fields.emailRecipients,
				displayName: "Email recipients",
				editorTemplate: "MultilineTextField",
				fieldType: "General",
				defaultValue: "",
				isRequired: true,
				regularExpression: emailsRegexp,
			},
		]
	},

};

export default widgetModule;
